


































































































































































/* note
kansain, seibishi: single select
hojoSeibishi: multiple select
hojoSeibishi + seibishi <= 3
*/
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import SubHeader from "@/components/SubHeader.vue";
import { InspectKbn, SeibiKbn } from "@/model/InspectKbn";
import { InspectStaff } from "@/model/InspectStaff";
import { InspectDetail } from "@/model/InspectDetail";
import requestService from "@/service/requestService";
import { Action, Getter } from "vuex-class";
import { SknUketsukeExtends } from "@/model/SknUketsukeExtends";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { MESSAGE } from "@/model/Message";
import { InspectionDetailState } from "@/store/modules/InspectionDetailStore";
import { LiftUse } from "@/model/LiftUse";
import { deepCopy, padNumber } from "@/service/util";
import ReservationDetailState from "@/store/reservation/state";

const namespaceInspect = "InspectionDetail";

@Component({
  components: {
    Header,
    SubHeader,
    ConfirmDialog
  }
})
export default class InspectionDetail extends Vue {
  isUserMode: boolean = false;
  inspectLine: InspectKbn[] = [];
  liftUse: LiftUse[] = [];
  shakenShurui: SeibiKbn[] = [];
  dataHojos: InspectStaff[] = [];
  dataKensains: InspectStaff[] = [];
  dataSeibishis: InspectStaff[] = [];

  reqService: any;
  deSelKensain: boolean = false;
  deSelSeibishi: boolean = false;
  deSelHojo: boolean = false;
  deSelSeibi: boolean = false;
  @Prop() disabledStart: boolean;
  showEditSeibiMenu: boolean = false;
  nowSelected: number[] = [-1, -1, -1, -1, -1, -1, -1];
  inspectionDetail: InspectDetail = {
    kensain: [],
    seibishi: [],
    hojoSeibishi: []
  };
  errorMsg: string = "";
  jizen: InspectKbn[] = [];

  $refs!: {
    errorDialog: ConfirmDialog;
    // askDialog: ConfirmDialog;
  };

  @Action("setInspectLine", { namespace: namespaceInspect })
  setInspectLine: any;
  @Action("setLiftUse", { namespace: namespaceInspect })
  setLiftUse: any;
  @Action("setShakenShurui", { namespace: namespaceInspect })
  setShakenShurui: any;
  @Action("setStaffHojo", { namespace: namespaceInspect })
  setStaffHojo: any;
  @Action("setStaffKensain", { namespace: namespaceInspect })
  setStaffKensain: any;
  @Action("setStaffSeibishi", { namespace: namespaceInspect })
  setStaffSeibishi: any;
  @Action("selectedInspectLine", { namespace: namespaceInspect })
  selectedInspectLine: any;
  @Action("save", { namespace: namespaceInspect })
  save: any;
  @Action("setProgressState", { namespace: "SubHeader" })
  setProgressState: any;

  @Getter("currentState", { namespace: namespaceInspect })
  inspectionState: InspectionDetailState;

  @Getter("getStaffKensain", { namespace: namespaceInspect })
  getStaffKensain: InspectStaff[];
  @Getter("getStaffSeibishi", { namespace: namespaceInspect })
  getStaffSeibishi: InspectStaff[];
  @Getter("getStaffHojo", { namespace: namespaceInspect })
  getStaffHojo: InspectStaff[];
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("sknUketsukeExtends", { namespace: "ReservationDetail" })
  sknUketsukeExtends: SknUketsukeExtends;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Action("setInspectLineCd", { namespace: namespaceInspect })
  setInspectLineCd: any;

  @Action("setSeibiMenuCd", { namespace: namespaceInspect })
  setSeibiMenuCd: any;

  @Getter("currentState", { namespace: "ReservationDetail" })
  reservationState: ReservationDetailState;

  @Action("clearState", { namespace: "Buhin" })
  clearBuhin: any;

  /** 2021-08-12 sh #7338 No.39 it does not reflect to shaken-shurui. [START] */
  @Getter("seibiMenuCd", { namespace: "InspectionDetail" })
  seibiMenuCd: any;
  /** 2021-08-12 sh #7338 No.39 it does not reflect to shaken-shurui. [END] */
  @Action("setJizen", { namespace: namespaceInspect })
  setJizen: any;

  @Action("setJizenCd", { namespace: namespaceInspect })
  setJizenCd: any;

  /** 2021-10-12 sh #7467 it does not check if jizen does not use. [START] */
  @Getter("isCanJizenMitsumori", { namespace: "FunctionSetting" })
  isCanJizenMitsumori: any;
  /** 2021-10-12 sh #7467 it does not check if jizen does not use. [END] */

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Action("setShakenShuruiNm", { namespace: namespaceInspect })
  setShakenShuruiNm: any;
  @Action("setShakenShuruiSeibiMenuUpdatedAt", { namespace: namespaceInspect })
  setShakenShuruiSeibiMenuUpdatedAt: any;
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  staffSize: number = 6;
  stateId: number = 0;
  stateNm: string = "";
  ownLift: string = "";
  loadingText: string = MESSAGE.Loading;
  loading: boolean = false;
  listStaffSelected: any = [];
  titleAsk: string = "";
  // msgAsk: string = "";
  // msgInprogress: string = "作業中ですが、選択しますか？";
  // tempColumn: string = "";
  // tempSelected: any = null;

  listDataSeibiMenu: any = [];
  defaultSeibiMenu: string = "";

  get workShubetsuCd() {
    if (this.reservationState) {
      return this.reservationState.uketsuke.workShubetsuCd;
    }
    return "";
  }
  disabledPrev: any = {
    shakenShurui: true,
    inspectLine: true,
    liftUse: true,
    staffKensain: true,
    staffSeibishi: true,
    staffHojo: true
    , jizen: true
  };
  disabledNext: any = {
    shakenShurui: false,
    inspectLine: false,
    liftUse: false,
    staffKensain: false,
    staffSeibishi: false,
    staffHojo: false
    , jizen: false
  };
  jizenFlg: boolean = false;

  created() {
    if (this.$route.meta == "user") {
      this.isUserMode = true;
    }
    if (window.outerHeight < 864) {
      this.staffSize = 5;
    }
    this.reqService = new requestService();
    this.initData();
    this.getJizenVal();
  }

  initData() {
    if (this.inspectionState.hasData) {
      this.getData();
    } else {
      this.reqService
        .getInsectionDetail(this.uketsukeExtendsId)
        .then((data: any) => {
          this.setProgressState({
            stateId: data.workProgressStateId,
            stateNm: data.workProgressStateNm
          });
          this.ownLift = data.liftUse;
          this.inspectionDetail = {
            hojoSeibishi: data.hojoSeibishi,
            inspectLineCd: data.inspectLineCd,
            inspectLineNm: data.inspectLineNm,
            kensain: data.kensain,
            liftUse: data.liftUse,
            seibishi: data.seibishi,
            shakenShuruiSeibiMenuCd: data.shakenShuruiSeibiMenuCd,
            shakenShuruiNm: data.shakenShuruiNm
            , jizenCd: data.jizenCd,
            jizenNm: data.jizenNm
          };
          this.$emit("setInspectionDetail", this.inspectionDetail);
          this.setInspectLineCd(data.inspectLineCd);
          this.setSeibiMenuCd(data.shakenShuruiSeibiMenuCd);
          /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
          this.setShakenShuruiNm(data.shakenShuruiNm);
          this.setShakenShuruiSeibiMenuUpdatedAt(data.shakenShuruiSeibiMenuUpdatedAt);
          /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
          this.setJizenCd(data.jizenCd);
          this.getData();
          if (data.updatedAt) {
            if (
              data.shakenShuruiSeibiMenuCd &&
              data.inspectLineCd &&
              data.liftUse &&
              data.kensain &&
              data.seibishi &&
              data.hojoSeibishi &&
              data.jizenCd
            ) {
              this.nowSelected[0] = 99;
              this.nowSelected[1] = 99;
              this.nowSelected[2] = 99;
              this.nowSelected[6] = 99;
              let listKansainSelected = data.kensain.map((staff: any) => {
                return staff.staffCd;
              });
              let listSeibishiSelected = data.seibishi.map((staff: any) => {
                return staff.staffCd;
              });
              let listHojoSeibishiSelected = data.hojoSeibishi.map(
                (staff: any) => {
                  return staff.staffCd;
                }
              );
              this.$nextTick(() => {
                this.nowSelected[3] = 99;
                this.nowSelected[4] = 99;
                this.nowSelected[5] = 99;
                if (data.kensain.length == 0) {
                  this.deSelKensain = true;
                }
                if (data.seibishi.length == 0) {
                  this.deSelSeibishi = true;
                }
                if (data.hojoSeibishi.length == 0) {
                  this.deSelHojo = true;
                }
              });

              this.listStaffSelected = [
                ...listKansainSelected,
                ...listSeibishiSelected,
                ...listHojoSeibishiSelected
              ];
              if (data.seibishi.length + data.hojoSeibishi.length > 3) {
                this.errorMsg = MESSAGE.ExceedStaffSeleced;
                this.$refs.errorDialog.onOpen();
              } else if (!this.isUserMode) {
                // this.disabledStart = false;
                this.$emit("setDisabledStart", false);
              }
            }
          }
        });
    }
  }

  getShakenShurui() {
    this.reqService.getSeibiMenuList().then(
      (res: any[]) => {
        if (res) {
          this.$set(this, "listDataSeibiMenu", deepCopy(res));
        }
        let shakenShuruiSeibiMenuCd = this.inspectionDetail
          .shakenShuruiSeibiMenuCd;
        let isSaved = shakenShuruiSeibiMenuCd != "";
        res.map(data => {
          if (
            (isSaved && shakenShuruiSeibiMenuCd == data.seibiMenuCd) ||
            (!isSaved &&
              this.defaultSeibiMenu &&
              this.defaultSeibiMenu == data.seibiMenuCd)
          ) {
            data.selected = "1";
            this.nowSelected[0] = 1;
          } else {
            data.selected = "0";
          }
        });
        this.$set(this, "shakenShurui", res);
        this.setShakenShurui(res);
      },
      (err: any) => {
        this.$set(this, "listDataSeibiMenu", []);
        this.$set(this, "shakenShurui", []);
        this.setShakenShurui([]);
      }
    );
  }

  mounted() {
    const arrStaffType = [
      "shakenShurui",
      "inspectLine",
      "liftUse",
      "staffKensain",
      "staffSeibishi",
      "staffHojo"
    ];
    arrStaffType.forEach((staffType: string) => {
      const list = document.getElementById(`list-${staffType}`);

      if (list) {
        list.addEventListener("scroll", () => {
          if (list.scrollTop === 0) {
            this.$set(this.disabledPrev, staffType, true);
          } else {
            this.$set(this.disabledPrev, staffType, false);
          }
          if (list.clientHeight + list.scrollTop >= list.scrollHeight) {
            this.$set(this.disabledNext, staffType, true);
          } else {
            this.$set(this.disabledNext, staffType, false);
          }
        });
      }
    });
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.onChangeSeibiMenuCd();
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
  }

  beforeDestroy() {
    const arrStaffType = [
      "shakenShurui",
      "inspectLine",
      "liftUse",
      "staffKensain",
      "staffSeibishi",
      "staffHojo"
    ];
    arrStaffType.forEach((staffType: string) => {
      const list = document.getElementById(`list-${staffType}`);
      if (list) {
        list.removeEventListener("scroll", e => {});
      }
    });
  }

  getData() {
    const shakenShurui = this.inspectionState.shakenShurui;
    if (shakenShurui.length > 0) {
      this.shakenShurui = shakenShurui;
      this.checkDisableStart(0, this.shakenShurui);
    } else {
      this.reqService.getWorkShubetsu().then((res: any) => {
        if (res) {
          let work = res.find(
            (e: any) => e.workShubetsuCd == this.workShubetsuCd
          );
          if (work) {
            this.defaultSeibiMenu = work.seibiMenuCd;
          }
        }
        this.getShakenShurui();
      });
    }

    const lines = this.inspectionState.inspectLine;
    if (lines.length > 0) {
      this.inspectLine = lines;
      this.checkDisableStart(1, this.inspectLine);
    } else {
      this.reqService
        .getKbnSkns("skn_inspect_line")
        .then((res: InspectKbn[]) => {
          res.map(data => {
            if (
              this.inspectionDetail.inspectLineCd &&
              +this.inspectionDetail.inspectLineCd == data.kbnKey
            ) {
              data.selected = "1";
              this.nowSelected[1] = 1;
            } else {
              data.selected = "0";
            }
          });
          this.$set(this, "inspectLine", res);
          this.setInspectLine(res);
        });
    }
    const lifts = this.inspectionState.liftUse;
    if (lifts.length > 0) {
      lifts.sort((a: any, b: any) => {
        a = a.num;
        b = b.num;
        return a === b ? 0 : a > b ? 1 : -1;
      });
      this.liftUse = lifts;
      this.checkDisableStart(2, this.liftUse);
    } else {
      this.reqService.getLiftUse().then((res: LiftUse[]) => {
        res.map(data => {
          if (
            this.inspectionDetail.liftUse &&
            this.inspectionDetail.liftUse == data.num
          ) {
            data.selected = "1";
            this.nowSelected[2] = 1;
          } else {
            data.selected = "0";
          }
        });
        res.sort((a: any, b: any) => {
          a = a.num;
          b = b.num;
          return a === b ? 0 : a > b ? 1 : -1;
        });
        this.$set(this, "liftUse", res);
        this.setLiftUse(res);
      });
    }
    const staffKensain = this.inspectionState.staffKensain;
    if (staffKensain.length > 0) {
      this.dataKensains = staffKensain;
      if (this.getStaffKensain.length == 0) {
        this.deSelKensain = true;
      }
      this.checkDisableStart(3, this.dataKensains, this.deSelKensain);
    } else {
      this.reqService.getStaffKensain().then((res: InspectStaff[]) => {
        // res = res.filter(
        //   data =>
        //     data.inProgress != 1 ||
        //     this.listStaffSelected.indexOf(data.staffCd) > -1
        // );
        this.dataKensains = res.map(data => {
          let selected = "0";
          if (this.inspectionDetail.kensain) {
            if (
              this.inspectionDetail.kensain.findIndex(
                kensain => data.staffCd == kensain.staffCd
              ) > -1
            ) {
              selected = "1";
              this.nowSelected[3] = 1;
            }
          }
          return { ...data, selected };
        });
        this.setStaffKensain(this.dataKensains);
      });
    }

    const staffSeibishi = this.inspectionState.staffSeibishi;
    if (staffSeibishi.length > 0) {
      this.dataSeibishis = staffSeibishi;
      if (this.getStaffSeibishi.length == 0) {
        this.deSelSeibishi = true;
      }
      this.checkDisableStart(4, this.dataSeibishis, this.deSelSeibishi);
    } else {
      this.reqService.getStaffSeibishi().then((res: InspectStaff[]) => {
        // res = res.filter(
        //   data =>
        //     data.inProgress != 1 ||
        //     this.listStaffSelected.indexOf(data.staffCd) > -1
        // );
        this.dataSeibishis = res.map(data => {
          let selected = "0";
          if (this.inspectionDetail.seibishi) {
            if (
              this.inspectionDetail.seibishi.findIndex(
                seibishi => data.staffCd == seibishi.staffCd
              ) > -1
            ) {
              selected = "1";
              this.nowSelected[4] = 1;
            }
          }
          return { ...data, selected };
        });
        this.setStaffSeibishi(this.dataSeibishis);
      });
    }

    const staffHojo = this.inspectionState.staffHojo;
    if (staffHojo.length > 0) {
      this.dataHojos = staffHojo;
      if (this.getStaffHojo.length == 0) {
        this.deSelHojo = true;
      }
      this.checkDisableStart(5, this.dataHojos, this.deSelHojo);
    } else {
      this.reqService.getStaffHojoseibishi().then((res: InspectStaff[]) => {
        // res = res.filter(
        //   data =>
        //     data.inProgress != 1 ||
        //     this.listStaffSelected.indexOf(data.staffCd) > -1
        // );
        this.dataHojos = res.map(data => {
          let selected = "0";
          if (this.inspectionDetail.hojoSeibishi) {
            if (
              this.inspectionDetail.hojoSeibishi.findIndex(
                hojoSeibishi => data.staffCd == hojoSeibishi.staffCd
              ) > -1
            ) {
              selected = "1";
              this.nowSelected[5] = 1;
            }
          }
          return { ...data, selected };
        });
        this.setStaffHojo(this.dataHojos);
      });
    }
    const jizens = this.inspectionState.jizen;
    if (jizens.length > 0) {
      this.jizen = jizens;
      this.checkDisableStart(6, this.jizen);
    } else {
      this.reqService
        .getKbnSkns("skn_jizen")
        .then((res: InspectKbn[]) => {
          res.map(data => {
            if (
              this.inspectionDetail.jizenCd &&
              +this.inspectionDetail.jizenCd == data.kbnKey
            ) {
              data.selected = "1";
              this.nowSelected[6] = 1;
            } else {
              data.selected = "0";
            }
          });
          this.$set(this, "jizen", res);
          this.setJizen(res);
        });
    }
  }

  selShakenShurui(code: string) {
    if (this.isUserMode) {
      return;
    }
    this.shakenShurui.map(data => {
      if (data.seibiMenuCd == code) {
        if (data.selected == "1") {
          data.selected = "0";
        } else {
          data.selected = "1";
        }
      } else {
        data.selected = "0";
      }
    });
    this.defaultSeibiMenu = code;
    this.setShakenShurui([...this.shakenShurui]);
    this.checkDisableStart(0, this.shakenShurui);
  }

  selInspectLine(kbnKey: number) {
    if (this.isUserMode) {
      return;
    }
    this.inspectLine.map(data => {
      if (data.kbnKey == kbnKey) {
        if (data.selected == "1") {
          data.selected = "0";
        } else {
          data.selected = "1";
        }
      } else {
        data.selected = "0";
      }
    });
    this.checkDisableStart(1, this.inspectLine);
  }
  selLiftUse(num: string, isUse: string, plateNo?: string) {
    if (this.isUserMode) {
      return;
    }
    this.liftUse.map(data => {
      if (data.num == num) {
        if (data.selected == "1") {
          data.selected = "0";
        } else {
          if (isUse == "1") {
            // this.msgAsk = `使用中のリフト${num}(${plateNo})を選択しますか？`;
            // this.titleAsk = "";
            // this.tempColumn = "lift";
            // this.tempSelected = num;
            // this.$refs.askDialog.onOpen();
            this.onMessage(`使用中のリフト${num}(${plateNo})を選択しました。`);
          }
          data.selected = "1";
        }
      } else {
        data.selected = "0";
      }
    });

    this.checkDisableStart(2, this.liftUse);
  }

  onInprogressStaff(staff: InspectStaff, column: string) {
    let staffType = "";
    if (column == "kansain") {
      staffType = "検査員";
    } else if (column == "seibishi") {
      staffType = "整備士";
    } else {
      staffType = "補助整備士";
    }
    this.onMessage(`作業中の${staffType}：${staff.staffNm}さんを選択しました。`);
    // // this.msgAsk = this.msgInprogress;
    // this.tempColumn = column;
    // this.titleAsk = staffType + "：" + staff.staffNm;
    // this.tempSelected = staff.staffCd;
    // this.$refs.askDialog.onOpen();
  }

  selStaffKensain(code: string, confirm: boolean = false) {
    if (this.isUserMode) {
      return;
    }
    this.dataKensains.map(data => {
      if (data.staffCd == code) {
        if (data.selected == "1") {
          data.selected = "0";
        } else {
          if (data.inProgress == 1 && !confirm) {
            this.onInprogressStaff(data, "kansain");
          }
          this.unselectDupStaff(code, 3);
          this.dataKensains.map(data => (data.selected = "0"));
          this.deSelKensain = false;
          data.selected = "1";
        }
      }
    });
    this.checkDisableStart(3, this.dataKensains, this.deSelKensain);
  }
  deSelectKensain() {
    if (this.isUserMode) {
      return;
    }
    if (!this.deSelKensain) {
      this.dataKensains.map(data => (data.selected = "0"));
    }
    this.deSelKensain = !this.deSelKensain;
    this.checkDisableStart(3, this.dataKensains, this.deSelKensain);
  }
  selStaffSeibishi(code: string, confirm: boolean = false) {
    if (this.isUserMode) {
      return;
    }
    this.dataSeibishis.map(data => {
      if (data.staffCd == code) {
        if (data.selected == "1") {
          data.selected = "0";
        } else {
          if (data.inProgress == 0 || confirm) {
            this.unselectDupStaff(code, 4);
          }
          if (this.dataHojos.filter(data => data.selected == "1").length < 3) {
            if (data.inProgress == 1 && !confirm) {
              this.onInprogressStaff(data, "seibishi");
            }
            this.dataSeibishis.map(data => (data.selected = "0"));
            this.deSelSeibishi = false;
            data.selected = "1";
          }
        }
      }
    });
    this.checkDisableStart(4, this.dataSeibishis, this.deSelSeibishi);
  }
  deSelectSeibishi() {
    if (this.isUserMode) {
      return;
    }
    if (!this.deSelSeibishi) {
      this.dataSeibishis.map(data => (data.selected = "0"));
    }
    this.deSelSeibishi = !this.deSelSeibishi;
    this.checkDisableStart(4, this.dataSeibishis, this.deSelSeibishi);
  }

  selStaffHojo(code: string, confirm: boolean = false) {
    if (this.isUserMode) {
      return;
    }
    this.dataHojos.map(data => {
      if (data.staffCd == code) {
        if (data.selected == "1") {
          data.selected = "0";
        } else {
          if (data.inProgress == 0 || confirm) {
            this.unselectDupStaff(code, 5);
          }
          if (this.checkValidCountSeibishi_Hojo()) {
            if (data.inProgress == 1 && !confirm) {
              this.onInprogressStaff(data, "hojoseibishi");
            }
            this.deSelHojo = false;
            data.selected = "1";
          }
        }
      }
    });
    this.checkDisableStart(5, this.dataHojos, this.deSelHojo);
  }
  deSelectHojo() {
    if (this.isUserMode) {
      return;
    }
    if (!this.deSelHojo) {
      this.dataHojos.map(data => (data.selected = "0"));
    }
    this.deSelHojo = !this.deSelHojo;
    this.checkDisableStart(5, this.dataHojos, this.deSelHojo);
  }

  checkDisableStart(index: number, arrData: any, isUnSelect?: boolean) {
    if (isUnSelect) {
      this.nowSelected[index] = 99;
    } else if (arrData) {
      this.nowSelected[index] = arrData.findIndex(
        (data: any) => data.selected == "1"
      );
    }
    if (this.isUserMode) {
      // this.disabledStart = true;
      this.$emit("setDisabledStart", true);
    } else {
      /** 2021-10-12 sh #7467 it does not check if jizen does not use. [START] */
      // const isStart: any = this.nowSelected.find(negative => negative == -1);
      /** 事前見積を利用しない場合は、0にしておく */
      let nowSelectedCopy: any = deepCopy(this.nowSelected);
      if (!this.isCanJizenMitsumori) {
        nowSelectedCopy[6] = 0;
      }
      const isStart: any = nowSelectedCopy.find((negative: any) => negative == -1);
      /** 2021-10-12 sh #7467 it does not check if jizen does not use. [END] */
      // this.disabledStart = isStart === -1;
      this.$emit("setDisabledStart", isStart === -1);
    }
  }

  setInspectDetail() {
    this.inspectionDetail.kensain = [];
    this.inspectionDetail.seibishi = [];
    this.inspectionDetail.hojoSeibishi = [];
    this.inspectionDetail.uketsukeCd = this.uketsukeCd;
    this.inspectionDetail.uketsukeExtendId = this.uketsukeExtendsId;
    this.inspectionDetail.yoyakuNo = this.yoyakuNo;
    this.inspectionDetail.updatedAt = this.sknUketsukeExtends.updatedAt;
    this.inspectionState.liftUse.filter(data => {
      if (data.selected == "1") {
        this.inspectionDetail.liftUse = data.num;
      }
    });
    this.inspectionState.shakenShurui.filter((data: SeibiKbn) => {
      if (data.selected == "1") {
        this.inspectionDetail.shakenShuruiSeibiMenuCd = String(
          data.seibiMenuCd
        );
        this.inspectionDetail.shakenShuruiNm = String(data.seibiMenuNm);

        /** #6430 change seibi_menu_cd 2020-10-28 sh [START] */
        this.inspectionDetail.isChangeShakenShuruiSeibiMenuCd = 0;
        if (this.inspectionState.shakenShuruiSeibiMenuCd) {
          if (this.inspectionState.shakenShuruiSeibiMenuCd != this.inspectionDetail.shakenShuruiSeibiMenuCd) {
            this.inspectionDetail.isChangeShakenShuruiSeibiMenuCd = 1;
          }
        }
        /** #6430 change seibi_menu_cd 2020-10-28 sh [END] */

        this.setSeibiMenuCd(data.seibiMenuCd);
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
        this.setShakenShuruiNm(data.seibiMenuNm);
        this.inspectionDetail.shakenShuruiSeibiMenuUpdatedAt = this.inspectionState.shakenShuruiSeibiMenuUpdatedAt;
        /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
        this.clearBuhin();
      }
    });
    this.inspectionState.inspectLine.filter(data => {
      if (data.selected == "1") {
        this.inspectionDetail.inspectLineCd = String(data.kbnKey);
        this.inspectionDetail.inspectLineNm = data.value;
        this.setInspectLineCd(data.kbnKey);
      }
    });
    this.getStaffKensain.filter(data => {
      if (data.selected == "1") {
        this.inspectionDetail.kensain.push({
          staffCd: data.staffCd,
          staffNm: data.staffNm
        });
      }
    });
    this.getStaffSeibishi.filter(data => {
      if (data.selected == "1") {
        this.inspectionDetail.seibishi.push({
          staffCd: data.staffCd,
          staffNm: data.staffNm
        });
      }
    });
    this.getStaffHojo.filter(data => {
      if (data.selected == "1") {
        this.inspectionDetail.hojoSeibishi.push({
          staffCd: data.staffCd,
          staffNm: data.staffNm
        });
      }
    });
    // this.inspectionDetail.resetInspectTime = this.isStartInspect ? 0: 1;
    this.inspectionState.jizen.filter((data: any) => {
      if (data.selected == "1") {
        this.inspectionDetail.jizenCd = String(data.kbnKey);
        this.inspectionDetail.jizenNm = data.value;
        this.setJizenCd(data.kbnKey);
      }
    });
    this.$emit("setInspectionDetail", this.inspectionDetail);
  }

  startInspect() {
    this.loading = true;
    this.setInspectDetail();
    this.reqService.saveInsectionDetail(this.inspectionDetail).then(
      (res: any) => {
        this.save();
        this.reqService.postNavigtion(this.uketsukeExtendsId);
        this.$router.push({ name: "carselection" });
      },
      (res: any) => {
        this.loading = false;
        if (res.status < 500 && res.rsltComment) {
          this.errorMsg = res.rsltComment;
        } else {
          this.errorMsg = MESSAGE.SystemError;
        }
        this.$refs.errorDialog.onOpen();
      }
    );
  }

  checkValidCountSeibishi_Hojo() {
    const seibishi = this.dataSeibishis.filter(data => data.selected == "1")
      .length;
    const hojo = this.dataHojos.filter(data => data.selected == "1").length;
    return seibishi + hojo < 3;
  }
  unselectDupStaff(code: string, colSelect: number) {
    if (colSelect != 3) {
      let dupKensain: any = this.dataKensains.find(
        data => data.staffCd == code && data.selected == "1"
      );
      if (dupKensain) {
        dupKensain.selected = "0";
        this.checkDisableStart(3, this.dataKensains, this.deSelKensain);
      }
    }
    if (colSelect != 4) {
      let dupSeibishi: any = this.dataSeibishis.find(
        data => data.staffCd == code && data.selected == "1"
      );
      if (dupSeibishi) {
        dupSeibishi.selected = "0";
        this.checkDisableStart(4, this.dataSeibishis, this.deSelSeibishi);
      }
    }
    if (colSelect != 5) {
      let dupHojo: any = this.dataHojos.find(
        data => data.staffCd == code && data.selected == "1"
      );
      if (dupHojo) {
        dupHojo.selected = "0";
        this.checkDisableStart(5, this.dataHojos, this.deSelHojo);
      }
    }
  }

  move(staffType: string, direction: number) {
    const list = document.getElementById(`list-${staffType}`);
    if (list) {
      setTimeout(() => {
        list.scrollTop += 62 * direction;
      });
    }
  }

  validate(index: number) {
    return this.nowSelected[index] != -1;
  }

  // onSubmitSelected() {
  //   if (this.tempColumn == "lift") {
  //     this.selLiftUse(this.tempSelected, "0");
  //   } else if (this.tempColumn == "kansain") {
  //     this.selStaffKensain(this.tempSelected, true);
  //   } else if (this.tempColumn == "seibishi") {
  //     this.selStaffSeibishi(this.tempSelected, true);
  //   } else if (this.tempColumn == "hojoseibishi") {
  //     this.selStaffHojo(this.tempSelected, true);
  //   }
  //   this.msgAsk = "";
  //   this.tempColumn = "";
  // }

  deSelectSeibi() {
    if (!this.deSelSeibi) {
      this.shakenShurui.map(data => (data.selected = "0"));
    }
    this.deSelSeibi = !this.deSelSeibi;
    this.checkDisableStart(0, this.shakenShurui, this.deSelSeibi);
  }

  callBackSaveSeibiMenu() {
    setTimeout(() => {
      this.getShakenShurui();
      if (!this.deSelSeibi) {
        this.shakenShurui.map(data => (data.selected = "0"));
      }
      this.deSelSeibi = false;
      this.checkDisableStart(0, this.shakenShurui, this.deSelSeibi);
    }, 500);
  }

  onMessage(msg: string) {
    this.$message({
      message: msg,
      type: "info",
      duration: 700,
      customClass: "msg-top shadow",
      showClose: true
    });
  }

  /** 2021-08-12 sh #7338 No.39 it does not reflect to shaken-shurui. [START] */
  @Watch("seibiMenuCd")
  onChangeSeibiMenuCd() {
    if (this.isUserMode) {
      this.shakenShurui.map(data => {
        if (data.seibiMenuCd == this.seibiMenuCd) {
          data.selected = "1";
        } else {
          data.selected = "0";
        }
      });
    } else {
      const selectedData = this.shakenShurui.filter(data => data.seibiMenuCd == this.seibiMenuCd);
      if (selectedData && selectedData.length == 1 && selectedData[0].selected != "1") {
        this.selShakenShurui(this.seibiMenuCd);
      }
    }
  }
  /** 2021-08-12 sh #7338 No.39 it does not reflect to shaken-shurui. [END] */

  selJizen(kbnKey: number) {
    if (this.isUserMode) {
      return;
    }
    this.jizen.map(data => {
      if (data.kbnKey == kbnKey) {
        if (data.selected == "1") {
          data.selected = "0";
        } else {
          data.selected = "1";
        }
      } else {
        data.selected = "0";
      }
    });
    this.checkDisableStart(6, this.jizen);
  }

  getJizenVal() {
    this.reqService.getJizenVal().then(
      (res: any) => {
        this.jizenFlg = res ? (res == '1' ? true: false): false;
      },
      (err: any) => {
      }
    );
  }

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  updateInsectionDetail(res: any) {
    if (res && res.body) {
      this.setSeibiMenuCd(res.body.shakenShuruiSeibiMenuCd);
      this.setShakenShuruiNm(res.body.shakenShuruiNm);
      this.setShakenShuruiSeibiMenuUpdatedAt(res.body.shakenShuruiSeibiMenuUpdatedAt);
    }
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
}
